import { appContainer } from '../contexts/app';
import Resource from './resource';
import { Map, List } from 'immutable';
import {
  fromImmutable,
  toImmutable,
  setInState,
  setListInState,
  deleteInState
} from './hooks';

const deleteUserInState = context => {
  appContainer.deleteIn(['users', context.result.user_id]);
  return context;
};

export default app => {
  const service = app.service('api/permissions');

  const PermissionRecord = Resource(
    service,
    {
      account_id: '',
      user_id: '',
      permissions: Map({
        resources: Map({
          buildings: List(),
          markerTypeCategories: List()
        }),
        edit: Map({
          resources: false,
          users: false,
          account: false
        }),
        groups: List()
      })
    },
    {}
  );

  appContainer.PermissionRecord = PermissionRecord;
  app.set('PermissionRecord', PermissionRecord);

  service.hooks({
    before: {
      all: [],
      find: [],
      get: [],
      create: [fromImmutable],
      update: [fromImmutable],
      patch: [fromImmutable],
      remove: []
    },

    after: {
      all: [toImmutable(PermissionRecord)],
      find: [setListInState('permissions')],
      get: [setInState('permissions')],
      create: [setInState('permissions')],
      update: [setInState('permissions'), setCurrentUserPerms],
      patch: [setInState('permissions'), setCurrentUserPerms],
      remove: [deleteInState('permissions'), deleteUserInState]
    },

    error: {
      all: [],
      find: [],
      get: [],
      create: [],
      update: [],
      patch: [],
      remove: []
    }
  });
};

// If we are working on the currentUser, update his/her
// permissions.
const setCurrentUserPerms = async context => {
  if (
    context.result.user_id === appContainer.state.getIn(['currentUser', '_id'])
  ) {
    const perms = context.result.get('permissions');
    appContainer.setIn(['currentUser', 'permissions'], perms);
  }
};



// WEBPACK FOOTER //
// ./src/feathers/permissions.js